import { DATE_REGEX, CURRENCY_REGEX, NUMBER_REGEX } from "./constant";
import moment from "moment";

export function inferDataType(obj) {
  const output = {};

  for (const key in obj) {
    let value = obj[key];

    // Matching date
    if (DATE_REGEX.test(value)) {
      output[key] = moment(value);
    } else if (CURRENCY_REGEX.test(value)) {
      output[key] = +value.slice(1, value.length - 1) * 100;
    } else if (NUMBER_REGEX.test(value)) {
      output[key] = parseFloat(value);
    } else {
      output[key] = value;
    }
  }

  return output;
}


export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
};